import { useEffect, useState } from 'react';

const PARTICLE_COUNT = 14;

// Warm colors for the skip celebration
const SKIP_COLORS = [
  '#2D6A4F', '#4A9470', '#D6EDE3',
  '#C4622D', '#E8C373', '#F5E0D4',
  '#2D6A4F', '#4A9470', '#E8C373',
  '#2D6A4F', '#C4622D', '#D6EDE3',
  '#4A9470', '#E8C373',
];

const truncate = (name, max = 45) => name && name.length > max ? name.slice(0, max) + '...' : name;

export default function DecisionModal({ item, decision, onDone }) {
  const isSkipped = decision === 'skipped';
  const [visible, setVisible] = useState(false);

  // Slight delay so the overlay entrance animation runs
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 20);
    return () => clearTimeout(t);
  }, []);

  const handleDone = () => {
    setVisible(false);
    // Wait for exit animation before unmounting
    setTimeout(onDone, 280);
  };

  const skipMessage = item.price
    ? `You let it simmer — and walked away. $${item.price.toFixed(2)} stays in your pocket.`
    : `You let it simmer — and walked away. That's real restraint.`;

  const buyMessage = `You simmered on it and decided it was worth it. Intentional purchase.`;

  return (
    <div
      className={`dm-overlay ${visible ? 'dm-overlay--in' : ''}`}
      role="dialog"
      aria-modal="true"
    >
      {/* Particles live in the overlay so they burst freely */}
      {isSkipped && (
        <div className="dm-particles" aria-hidden="true">
          {Array.from({ length: PARTICLE_COUNT }, (_, i) => (
            <span
              key={i}
              className={`dm-particle dm-particle--${i}`}
              style={{ background: SKIP_COLORS[i] }}
            />
          ))}
        </div>
      )}

      <div className={`dm-card dm-card--${decision} ${visible ? 'dm-card--in' : ''}`}>
        <div className={`dm-icon-wrap dm-icon-wrap--${decision}`}>
          {isSkipped ? (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              {/* Leaf */}
              <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/>
              <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>
            </svg>
          ) : (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          )}
        </div>

        <h2 className="dm-heading">
          {isSkipped ? 'Stayed in your pocket.' : 'Intentional purchase.'}
        </h2>

        {item.name && (
          <p className="dm-item-name">{truncate(item.name)}</p>
        )}

        <p className="dm-body">
          {isSkipped ? skipMessage : buyMessage}
        </p>

        {isSkipped && item.price && (
          <div className="dm-savings-badge">
            <SavingsTicker target={item.price} />
            <span className="dm-savings-label">saved</span>
          </div>
        )}

        <button className={`dm-done dm-done--${decision}`} onClick={handleDone}>
          Done
        </button>
      </div>
    </div>
  );
}

function SavingsTicker({ target }) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const duration = 900;
    const startTime = performance.now();
    let raf;

    const tick = (now) => {
      const t = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(target * eased);
      if (t < 1) raf = requestAnimationFrame(tick);
    };

    // Small delay so the card entrance animation finishes first
    const timer = setTimeout(() => { raf = requestAnimationFrame(tick); }, 350);
    return () => { clearTimeout(timer); cancelAnimationFrame(raf); };
  }, [target]);

  return <span className="dm-savings-amount">${display.toFixed(2)}</span>;
}
